import { render, staticRenderFns } from "./MWizard.vue?vue&type=template&id=4bfb4c4a&scoped=true&"
import script from "./MWizard.vue?vue&type=script&lang=js&"
export * from "./MWizard.vue?vue&type=script&lang=js&"
import style0 from "./MWizard.vue?vue&type=style&index=0&id=4bfb4c4a&scoped=true&lang=css&"
import style1 from "./MWizard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb4c4a",
  null
  
)

export default component.exports